<template>
  <QuadroPrincipal
    :key="getRenderKey"
    class="carga-liquida-container"
    :classe="classe"
    :titulo="'CARGA LÍQUIDA'"
  >
    <div v-if="!selecionouCargaLiquida">
      <div
        class="icms-carga-liquida-container"
        v-for="(cargaLiquida, index) in dadosResultado"
        :key="index"
      >
        <RadioButton :imposto="cargaLiquida" :classe="classe" :seleciona="seleciona" />
        <Registro
          v-if="cargaLiquida.id_imposto == 100 || isencao"
          paddingSemCheckBox
          :key="`registro${getRenderKey}`"
        >
          <Cabecalho paddingBottom :titulo="cargaLiquida.label" />
          <Inaplicabilidade :texto="cargaLiquida.texto_inaplicabilidade" />
        </Registro>
        <Registro v-else :paddingSemCheckBox="dadosResultado.length <= 1">
          <Registro
            semPaddingBottom
            v-if="
              cargaLiquida.mva ||
                cargaLiquida.percentual_carga_liquida ||
                cargaLiquida.percentual_carga_liquida
            "
          >
            <Cabecalho
              v-if="cargaLiquida.percentual_carga_liquida"
              tipo="porcentagem2"
              paddingBottom
              titulo="Percentual de Carga Líquida"
              :aliquota="cargaLiquida.percentual_carga_liquida"
            />
            <div
              v-if="
                cargaLiquida.percentual_carga_liquida && (cargaLiquida.mva || cargaLiquida.fecp)
              "
              class="separador"
            />
            <Cabecalho
              v-if="cargaLiquida.mva"
              tipo="porcentagem2"
              paddingBottom
              titulo="MVA:"
              :aliquota="cargaLiquida.mva"
            />
            <div v-if="cargaLiquida.mva && cargaLiquida.fecp" class="separador" />
            <Cabecalho
              v-if="cargaLiquida.fecp"
              tipo="porcentagem2"
              paddingBottom
              titulo="FECP:"
              :aliquota="cargaLiquida.fecp"
            />
          </Registro>

          <Registro semPaddingBottom v-if="cargaLiquida.adicional_sn">
            <Descricao
              :titulo="'Adicional do Simples Nacional'"
              :descricao="cargaLiquida.adicional_sn"
            />
            <div
              v-if="cargaLiquida.adicional_sn && cargaLiquida.base_legal_adicional_sn"
              class="separador"
            />
            <BaseLegal
              cargaLiquida
              v-if="cargaLiquida.base_legal_adicional_sn"
              :base_legal="cargaLiquida.base_legal_adicional_sn"
              :classe="classe"
            />
          </Registro>

          <Registro semPaddingBottom v-if="cargaLiquida.adicional_produto_importado">
            <Descricao
              :titulo="'Adicional do Simples Nacional'"
              :descricao="cargaLiquida.adicional_produto_importado"
            />
            <div
              v-if="
                cargaLiquida.adicional_produto_importado &&
                  cargaLiquida.base_legal_adicional_produto_importado
              "
              class="separador"
            />
            <BaseLegal
              cargaLiquida
              v-if="cargaLiquida.base_legal_adicional_produto_importado"
              :base_legal="cargaLiquida.base_legal_adicional_produto_importado"
              :classe="classe"
            />
          </Registro>

          <Registro semPaddingBottom v-if="cargaLiquida.mva_st_exclusos">
            <Cabecalho
              v-if="cargaLiquida.mva_st_exclusos"
              tipo="porcentagem2"
              paddingBottom
              titulo="MVA ST Contribuintes Excluídos"
              :aliquota="cargaLiquida.mva_st_exclusos"
            />
            <Notificacao
              v-if="!!cargaLiquida.mva_st_exclusos_alerta"
              :tipo="'alerta'"
              :texto="cargaLiquida.mva_st_exclusos_alerta"
            />
            <div
              v-if="
                (cargaLiquida.mva_st_exclusos_alerta || cargaLiquida.mva_st_exclusos) &&
                  cargaLiquida.base_legal_mva_st_exclusos
              "
              class="separador"
            />

            <BaseLegal
              cargaLiquida
              v-if="cargaLiquida.base_legal_mva_st_exclusos"
              :base_legal="cargaLiquida.base_legal_mva_st_exclusos"
              :classe="classe"
            />
          </Registro>

          <Notificacao v-if="cargaLiquida.alerta" :tipo="'alerta'" :texto="cargaLiquida.alerta" />
          <GrupoNotificacao
            v-if="cargaLiquida"
            :registro="cargaLiquida"
            :cnae="cargaLiquida.lista_cnaes"
          />

          <div
            v-if="
              cargaLiquida.base_legal_incidencia && (cargaLiquida.lista_cnaes || cargaLiquida.obs)
            "
            class="separador"
          />
          <BaseLegal
            v-if="cargaLiquida.base_legal_incidencia"
            :base_legal="cargaLiquida.base_legal_incidencia"
            :classe="classe"
          />
        </Registro>
      </div>
    </div>
    <div v-else>
      <div class="icms-carga-liquida-container">
        <EditButton v-if="dadosResultado.length > 1" :classe="classe" :edita="edita" />
        <Registro
          v-if="cargaLiquidaSelecionada.id_imposto == 100 || isencao"
          paddingSemCheckBox
          :key="`registro${getRenderKey}`"
        >
          <Cabecalho paddingBottom :titulo="cargaLiquidaSelecionada.label" />
          <Inaplicabilidade :texto="cargaLiquidaSelecionada.texto_inaplicabilidade" />
        </Registro>

        <Registro v-else :paddingSemCheckBox="dadosResultado.length <= 1">
          <Registro
            semPaddingBottom
            v-if="
              cargaLiquidaSelecionada.mva ||
                cargaLiquidaSelecionada.percentual_carga_liquida ||
                cargaLiquidaSelecionada.percentual_carga_liquida
            "
          >
            <Cabecalho
              v-if="cargaLiquidaSelecionada.percentual_carga_liquida"
              tipo="porcentagem2"
              paddingBottom
              titulo="Percentual de Carga Líquida"
              :aliquota="cargaLiquidaSelecionada.percentual_carga_liquida"
            />
            <div
              v-if="
                cargaLiquidaSelecionada.percentual_carga_liquida &&
                  (cargaLiquidaSelecionada.mva || cargaLiquidaSelecionada.fecp)
              "
              class="separador"
            />
            <Cabecalho
              v-if="cargaLiquidaSelecionada.mva"
              tipo="porcentagem2"
              paddingBottom
              titulo="MVA:"
              :aliquota="cargaLiquidaSelecionada.mva"
            />
            <div
              v-if="cargaLiquidaSelecionada.mva && cargaLiquidaSelecionada.fecp"
              class="separador"
            />
            <Cabecalho
              v-if="cargaLiquidaSelecionada.fecp"
              tipo="porcentagem2"
              paddingBottom
              titulo="FECP:"
              :aliquota="cargaLiquidaSelecionada.fecp"
            />
          </Registro>

          <Registro semPaddingBottom v-if="cargaLiquidaSelecionada.adicional_sn">
            <Descricao
              :titulo="'Adicional do Simples Nacional'"
              :descricao="cargaLiquidaSelecionada.adicional_sn"
            />
            <div
              v-if="
                cargaLiquidaSelecionada.adicional_sn &&
                  cargaLiquidaSelecionada.base_legal_adicional_sn
              "
              class="separador"
            />
            <BaseLegal
              cargaLiquida
              v-if="cargaLiquidaSelecionada.base_legal_adicional_sn"
              :base_legal="cargaLiquidaSelecionada.base_legal_adicional_sn"
              :classe="classe"
            />
          </Registro>

          <Registro semPaddingBottom v-if="cargaLiquidaSelecionada.adicional_produto_importado">
            <Descricao
              :titulo="'Adicional do Simples Nacional'"
              :descricao="cargaLiquidaSelecionada.adicional_produto_importado"
            />
            <div
              v-if="
                cargaLiquidaSelecionada.adicional_produto_importado &&
                  cargaLiquidaSelecionada.base_legal_adicional_produto_importado
              "
              class="separador"
            />
            <BaseLegal
              cargaLiquida
              v-if="cargaLiquidaSelecionada.base_legal_adicional_produto_importado"
              :base_legal="cargaLiquidaSelecionada.base_legal_adicional_produto_importado"
              :classe="classe"
            />
          </Registro>

          <Registro semPaddingBottom v-if="cargaLiquidaSelecionada.mva_st_exclusos">
            <Cabecalho
              v-if="cargaLiquidaSelecionada.mva_st_exclusos"
              tipo="porcentagem2"
              paddingBottom
              titulo="MVA ST Contribuintes Excluídos"
              :aliquota="cargaLiquidaSelecionada.mva_st_exclusos"
            />
            <Notificacao
              v-if="!!cargaLiquidaSelecionada.mva_st_exclusos_alerta"
              :tipo="'alerta'"
              :texto="cargaLiquidaSelecionada.mva_st_exclusos_alerta"
            />
            <div
              v-if="
                (cargaLiquidaSelecionada.mva_st_exclusos_alerta ||
                  cargaLiquidaSelecionada.mva_st_exclusos) &&
                  cargaLiquidaSelecionada.base_legal_mva_st_exclusos
              "
              class="separador"
            />

            <BaseLegal
              cargaLiquida
              v-if="cargaLiquidaSelecionada.base_legal_mva_st_exclusos"
              :base_legal="cargaLiquidaSelecionada.base_legal_mva_st_exclusos"
              :classe="classe"
            />
          </Registro>

          <Notificacao
            v-if="cargaLiquidaSelecionada.alerta"
            :tipo="'alerta'"
            :texto="cargaLiquidaSelecionada.alerta"
          />
          <GrupoNotificacao
            v-if="cargaLiquidaSelecionada"
            :registro="cargaLiquidaSelecionada"
            :cnae="cargaLiquidaSelecionada.lista_cnaes"
          />

          <div
            v-if="
              cargaLiquidaSelecionada.base_legal_incidencia &&
                (cargaLiquidaSelecionada.lista_cnaes || cargaLiquidaSelecionada.obs)
            "
            class="separador"
          />
          <BaseLegal
            v-if="cargaLiquidaSelecionada.base_legal_incidencia"
            :base_legal="cargaLiquidaSelecionada.base_legal_incidencia"
            :classe="classe"
          />
        </Registro>
      </div>
    </div>
  </QuadroPrincipal>
</template>

<script>
import BaseLegal from "@/components/BaseLegal/BaseLegal.vue";
import Cabecalho from "@/components/Cabecalho/Cabecalho.vue";
import Descricao from "@/components/Descricao/Descricao.vue";
import Inaplicabilidade from "@/components/Inaplicabilidade/Inaplicabilidade.vue";
import QuadroPrincipal from "@/components/QuadroPrincipal/QuadroPrincipal.vue";
import QuadroZebra from "@/components/QuadroZebra/QuadroZebra.vue";
import Registro from "@/components/Registro/Registro.vue";
import Notificacao from "@/components/Notificacao/Notificacao.vue";
import Observacoes from "@/components/Observacoes/Observacoes.vue";
import GrupoNotificacao from "@/components/GrupoNotificacao/GrupoNotificacao.vue";
import RadioButton from "@/components/Button/RadioButton.vue";
import EditButton from "@/components/Button/EditButton.vue";

import stringFormatMixin from "@/mixins/stringFormatMixin";
import { mapGetters } from "vuex";

export default {
  name: "ResultadoCargaLiquida",

  mixins: [stringFormatMixin],

  props: {
    dados: Object | Array,
    cargaLiquidaSelecionada: Object | Array,
    selecionouCargaLiquida: Boolean,
    seleciona: Function,
    edita: Function,
    isencao: Boolean
  },

  components: {
    BaseLegal,
    Cabecalho,
    Descricao,
    Inaplicabilidade,
    QuadroPrincipal,
    GrupoNotificacao,
    QuadroZebra,
    Registro,
    Notificacao,
    Observacoes,
    RadioButton,
    EditButton
  },

  data() {
    return {
      classe: "carga_liquida"
    };
  },

  created() {
    if (this.dadosResultado && this.dadosResultado.length == 1) {
      this.seleciona(this.dadosResultado[0]);
    }
  },

  computed: {
    ...mapGetters("reRender", ["getRenderKey"]),
    dadosResultado() {
      return this.dados.base;
    }
  },

  methods: {}
};
</script>

<style lang="scss" scoped>
.icms-carga-liquida-container {
  display: flex;

  &:not(:last-child) {
    margin-bottom: 1rem;
  }
}
// .carga-liquida-container {
// padding-left: 2.5rem;
// }

// .separador {
//   margin-top: 1rem;
// }

.registro-content {
  margin-bottom: 7px;

  label {
    margin-bottom: 2rem;
    font-size: 1rem;
  }

  &:last-child {
    margin-bottom: 0;
  }
}
@media only print {
  .carga-liquida-container {
    padding-left: 10px;
  }
}
</style>
